export default __webpack_public_path__ + "static/img-point-fourth-03218677f9a69ac456fa1687d05ef9a8.png";